<template>
  <div>
    <div
        v-if="isDataLoading"
        id="loading-bg__cus"
        class="fs-loading__cus"
        style="
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9999999;
      "
    ></div>
    <b-card class="col-12" no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12">
            <h4>
              Lịch gửi SMS/Thông báo tổng hợp
              <a
                  v-b-tooltip.hover.top="'Lấy lại danh sách!'"
                  class="btn-icon"
                  @click="$router.go()"
              >
                <feather-icon icon="RepeatIcon"
                />
              </a>
            </h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <full-calendar
                ref="refCalendar"
                :options="calendarOptions"
                class="full-calendar"
            />
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>
<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";
import {VueGoodTable} from "vue-good-table";
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardText,
  BCol,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadioGroup,
  BFormSelect,
  BFormTextarea,
  BInputGroup,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip,
  VBTooltip,
} from "bootstrap-vue";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import Ripple from "vue-ripple-directive";
import "@core/scss/vue/libs/vue-good-table.scss";
import Select2 from "v-select2-component";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import Vue from "vue";
import VueExcelXlsx from "vue-excel-xlsx";
import FullCalendar from "@fullcalendar/vue";
import useCalendar from "./useCalendar";

Vue.use(VueExcelXlsx);

export default {
  components: {
    BFormDatepicker,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    VueGoodTable,
    Select2,
    BTabs,
    BTab,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BFormTextarea,
    BCardText,
    BInputGroup,
    flatPickr,
    FullCalendar,
  },

  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  async mounted() {
    this.clearEventData();
  },
  methods: {
    onGetInitData() {
    },
    getDateTime(e) {
      return moment(e).isValid() ? moment(e).format("DD/MM/YYYY HH:mm:ss") : "";
    },
  },
  setup() {
    const {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      fetchEvents,
      refetchEvents,
      calendarOptions,
      isDataLoading,

      // ----- UI ----- //
      isEventHandlerSidebarActive,
    } = useCalendar();

    // fetchEvents();

    return {
      refCalendar,
      isCalendarOverlaySidebarActive,
      event,
      clearEventData,
      addEvent,
      updateEvent,
      removeEvent,
      refetchEvents,
      calendarOptions,
      isDataLoading,
      // ----- UI ----- //
      isEventHandlerSidebarActive,
    };
  },
  data() {
    return {
      isCreateForm: false,
      appointmentTime: null,
      callStatusSelected: 1,
      detailColumnExtra: [],
      selectedTab: 0,
      selectedOrderTime: 0,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 10,
        id: "",
        createDate: "",
        startDate: "",
        endDate: "",
        status: 0,
        type: 0,
      },
      totalRecords: 0,
      isLoading: false,
      callStatus: [],
      group: [],
      questionType: [],
      status: [
        {
          value: "",
          text: "Tất cả",
        },
        {
          value: 1,
          text: "Đủ điều kiện",
        },
        {
          value: 0,
          text: "Không đủ điều kiện",
        },
      ],
      tableData: [],
      exportTableData: [],
      selectedRecord: null,
      detailQuestions: [],
      detailQuestionExtra: {},
      fields: [
        {
          field: "action",
          filterOptions: {enabled: false, placeholder: ""},
          label: "Action",
          required: true,
          disabled: true,
          width: "100px",
        },
      ],
      timeOut: null,
      dropListSelectData: [],
      events: [
        {
          title: "simple event",
          start: "2023-04-04",
        },
        {
          title: "event with URL",
          url: "https://www.google.com/",
          start: "2023-04-05",
        },
      ],
      blankEvent: {
        title: "TTTTT",
        start: "2023-04-04",
        end: "2023-04-04",
        allDay: true,
      },
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/apps/calendar.scss";

.modal-activated-order {
  height: 700px;
  color: #000000;
}

.col-700-scroll {
  height: 680px;
  overflow: auto;
}

.vpbank-tb-container .line-numbers,
th.vgt-left-align {
  background: linear-gradient(#f4f5f8, #f1f3f6) !important;
}

.vpbank-tb-container td {
  height: 34.4px !important;
}
</style>
<style scoped>
.error-txt small {
  color: red;
}

.unselected {
  background: rgb(175, 175, 175) !important;
  border: rgb(175, 175, 175) !important;
}

.text-end {
  text-align: end;
}

.action-col {
  width: 100%;
  display: flex;
  justify-content: center;
}

.order-id:hover {
  cursor: pointer;
  font-weight: bold;
  color: rgb(34, 100, 243);
}

.detail-custom-table {
  width: 100%;
}

.detail-custom-table {
  display: inline-table;
  border: solid 1px rgb(207 207 207);
}

.detail-custom-table th,
.detail-custom-table td {
  border: solid 1px rgb(207 207 207);
  padding: 5px 10px;
}

.detail-custom-table th {
  vertical-align: baseline;
}

.history-call__header {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.history-call__header h5 {
  margin: 0;
}

.note-question {
  font-style: italic;
  color: rgb(233, 71, 22);
  margin-bottom: 9px;
}

.action-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.action-container button {
  margin: 0 10px;
}

.status-info {
  padding: 4px 8px;
  border-radius: 5px;
  background: rgb(242, 242, 112);
  color: red;
  font-weight: bold;
}

.fs-loading__cus {
  display: none;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: #111;
  opacity: 0.7;
  z-index: 1000;
}

.fs-loading__cus::after {
  content: "";
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -25px 0 0 -25px;
  width: 50px;
  height: 50px;
  border-left: 3px solid #e91c27;
  border-top: 3px solid #e91c27;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -webkit-animation: rotate360 1.5s infinite;
  animation: rotate360 1.5s infinite linear;
  z-index: 1000;
}

#loading-bg__cus {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: block;
  position: absolute;
  z-index: 99999;
}
</style>
